<div class="pro-listing-search" [class.pro-listing-search--services]="displayServices">
  <kz-filters
    [filtersContext]="bannerType === 'pro-box' ? 'box' : 'decorator'">
    <kz-filter-item class="filter--geo">
      <kz-icons name="compass"></kz-icons>
      <kz-filter-input [hasSelectedItem]="!!geo" (reset)="resetGeo($event)">
        <input
          *ngIf="isBrowser"
          appAutocompleteOff
          type="text"
          class="kz-textbox--gm"
          placeholder="Find place"
          i18n-placeholder="@@pro.listing.search.city.placeholder"
          id="kz-annuaire-search--address"
          #inputGeoloc
          [value]="geoTmp"
          (focus)="selectAllContent($event)"
          (mouseup)="$event.preventDefault()"
          appGooglePlaceAutocomplete
(onSelect)="onAddressSelected($event)">
      </kz-filter-input>
      <div class="filter--geo--geolocate" (click)="geolocateMe()">
        <kz-icons name="crosshair"></kz-icons>
        <div i18n="@@pro.listing.search.geolocateMe">Geolocate me</div>
      </div>
    </kz-filter-item>

    <kz-filter-item class="filter--half--force" *ngIf="!displayServices" [class.kz-filter-item--loading]="loading == true">
      <kz-icons name="search"></kz-icons>
      <kz-filter-input>
        <input
         type="text"
         class="kz-textbox--brand"
         placeholder="Search a decorator"
         i18n-placeholder="@@pro.listing.search.brand.placeholder"
         (keyup)="searchBrand()"
         [(ngModel)]="brand">
      </kz-filter-input>
    </kz-filter-item>


    <kz-filter-item class="filter--filterBy">
      <kz-dropdown  [dropdownPosition]="'center'" [dropdownSize]="'small'">
        <span label>
          <kz-icons name="filter"></kz-icons>
          <ng-container i18n="@@pro.listing.search.filterCoachs" *ngIf="!displayServices">Filter coachs</ng-container>
          <ng-container i18n="@@pro.listing.search.filterServices" *ngIf="displayServices">Filter services</ng-container>
        </span>

        <div *appFilterDropdownItem>
          <strong header i18n="@@pro.listing.search.byService">By service</strong>
        </div>

        <div *appFilterDropdownItem
             class="filter--afar"
        >
          <kz-checkbox-toggle>
            <input class="kz-checkbox" #checkbox
                   type="checkbox"
                   id="coachDistance"
                   name="coachDistance"
                   [(ngModel)]="coachDistance"
                   (change)="toggleLocationFilter($event)"/>
            <span labelRight>
              <kz-icons name="laptop"></kz-icons>
              <span class="label" i18n="@@pro.listing.search.distance">Afar</span>
            </span>
          </kz-checkbox-toggle>

        </div>

        <div *appFilterDropdownItem
             class="filter--home"
        >
          <kz-checkbox-toggle>
            <input class="kz-checkbox" #checkbox
                   type="checkbox"
                   id="atHome"
                   name="atHome"
                   [(ngModel)]="atHome"
                   (change)="toggleLocationFilter($event)"/>
            <span labelRight>
              <kz-icons name="home"></kz-icons>
              <span class="label" i18n="@@pro.listing.search.atHome">At home</span>
            </span>
          </kz-checkbox-toggle>
        </div>

        <ng-container >

          <ng-container *appFilterDropdownItem>
            <strong header i18n="@@pro.listing.search.onlyFilter">Only filter</strong>
          </ng-container>

          <ng-container *ngIf="!displayServices">
            <div *appFilterDropdownItem
                 class="filter--favorites"
                 (click.appAccessControl)="!!$event"
            >
              <kz-field absErrorMsg="true">
                <input kzCheckBox type="checkbox" [(ngModel)]="showFavorites" (change)="toggleFavorites()" id="kz-checkbox-favorites"
                />
                <label kzLabel for="kz-checkbox-favorites">
                  <kz-icons name="like"></kz-icons>
                  <span class="label" i18n="@@pro.listing.search.favorites">marked as favorite</span>
                </label>
              </kz-field>
            </div>
          </ng-container>
          <!-- <div *appFilterDropdownItem
               class="filter--boxable">
            <kz-field absErrorMsg="true">
              <input kzCheckBox type="checkbox" (change)="toggleBoxable()" [(ngModel)]="boxFiltered"  id="kz-checkbox-boxable"
              />
              <label kzLabel for="kz-checkbox-boxable">
                <kz-icons name="gift"></kz-icons>
                <span class="label" *ngIf="!displayServices" i18n="@@pro.listing.search.boxable">that provide box offers</span>
                <span class="label" *ngIf="displayServices" i18n="@@pro.listing.search.offers-boxable">box offers</span>
              </label>
            </kz-field>

          </div>-->
        </ng-container>

      </kz-dropdown>
    </kz-filter-item>

    <kz-filter-item class="filter--style-type">
      <kz-dropdown [hasSelectedItem]="!!itemSelected" (reset)="resetSearch($event)" [dropdownSize]="'big'">
        <span label>
          <ng-container *ngIf="displayServices">
          <kz-icons name="menu"></kz-icons>
            <ng-container i18n="@@pro.listing.search.findByType.empty" *ngIf="!itemSelected">Find by type</ng-container>
            <ng-container i18n="@@pro.listing.search.findByType.type" *ngIf="itemSelected">Type : {{ itemSelected.name }}</ng-container>
          </ng-container>
          <ng-container *ngIf="!displayServices">
            <kz-icons name="coaching"></kz-icons>
            <ng-container i18n="@@pro.listing.search.findByStyle.empty" *ngIf="!itemSelected">Find by style</ng-container>
            <ng-container i18n="@@pro.listing.search.findByStyle.style" *ngIf="itemSelected">Style : {{ itemSelected.name }}</ng-container>
          </ng-container>
        </span>
        <strong header i18n="@@pro.listing.search.types.choose" *ngIf="displayServices">Choose your type</strong>
        <strong header i18n="@@pro.listing.search.choose" *ngIf="!displayServices">Choose your style</strong>
        <ng-container *ngFor="let item of items; trackBy: trackById">
          <a *appFilterDropdownItem
             [routerLink]="[].concat(['/pro'], jobPath, cityPath, servicesPath,  boxPath, [(displayServices ? 'type-' : 'style-') + item.nameSlug]) | kzLocalize"
             [queryParams]="{page: null}" queryParamsHandling="merge">
            <app-filter-dropdown-item-img
              *ngIf="item.image"
              [ngClass]="{'active': itemSelected && itemSelected.nameSlug == item.nameSlug}"
              [img]="item.image"
              [alt]="'Style ' + item.name"
            ></app-filter-dropdown-item-img>
            <span>{{ item.name }}</span>
          </a>
        </ng-container>
      </kz-dropdown>
    </kz-filter-item>

    <kz-filter-item class="filter--sort" *ngIf="displayServices && !boxFiltered">
      <kz-dropdown [hasSelectedItem]="!!currentSort" (reset)="resetSort($event)" [dropdownPosition]="'center'" [dropdownSize]="'small'">
        <span label>
          <ng-container *ngIf="!currentSort">
            <kz-icons name="sort"></kz-icons>
            <ng-container i18n="@@pro.listing.search.sort.services">Sort decoration offers</ng-container>
          </ng-container>
          <ng-container *ngIf="currentSort == 'ASC'">
            <kz-icons name="sort_asc"></kz-icons>
            <ng-container i18n="@@pro.listing.search.sorted.asc">Sorted by ascendant price</ng-container>
          </ng-container>
          <ng-container *ngIf="currentSort == 'DESC'">
            <kz-icons name="sort_desc"></kz-icons>
            <ng-container i18n="@@pro.listing.search.sorted.desc">Sorted by descendant price</ng-container>
          </ng-container>
        </span>
        <span *appFilterDropdownItem [ngClass]="{'active': currentSort == 'ASC'}" (click)="currentSort='ASC'; search()"><kz-icons name="sort_asc"></kz-icons><ng-container i18n="@@pro.listing.search.sort.asc">Sort by ascendant price</ng-container></span>
        <span *appFilterDropdownItem [ngClass]="{'active': currentSort == 'DESC'}" (click)="currentSort='DESC'; search()"><kz-icons name="sort_desc"></kz-icons><ng-container i18n="@@pro.listing.search.sort.desc">Sort by descendant price</ng-container></span>
      </kz-dropdown>
    </kz-filter-item>

    <div class="kz-filter-item filter--half filter--jobs" *ngIf="!servicesPath[0]  && !boxPath[0] && !itemSelected">
      <a kzButton buttonContext="decorator" buttonTxtStyle="none"
         *ngIf="!jobPath[0] || jobPath[0] === 'interior-architect'"
         [routerLink]="['/', 'pro', 'interior-decorator'] | kzLocalize"><span i18n="@@pro.listing.search.interiorDecoratorLink">Interior decorators</span></a>
      <a kzButton buttonContext="decorator" buttonTxtStyle="none"
         *ngIf="!jobPath[0] || jobPath[0] === 'interior-decorator'"
         [routerLink]="['/', 'pro', 'interior-architect'] | kzLocalize"><span i18n="@@pro.listing.search.interiorArchitectLink">Interior architects</span></a>
    </div>

    <kz-mesh-link-container class="kz-filter-item filter--cities" meshLinkBreakPoint="768"
                            *ngIf="!!jobPath[0] && !servicesPath[0]  && !boxPath[0] && !itemSelected && citiesKeyList?.length">
      <ng-container *ngFor="let cityKey of citiesKeyList; let i = index;" >
        <a kzMeshLink meshLinkType="secondary" meshLinkBreakPoint="768"
           *ngIf="cityPath!=cityKey && citiesList[cityKey][jobPath[0]] == true"
           [routerLink]="['/', 'pro', jobPath[0], cityKey] | kzLocalize">{{  citiesList[cityKey].label }}</a>
      </ng-container>
    </kz-mesh-link-container>

  </kz-filters>

</div>
